import * as actionTypes from "../actionTypes";

const initialState = {
  loading: false,
  cpManagersList: null,
  cpManagersListError: null,
  cpContractList: null,
  cpContractListError: null,
  cpLoading: false,
  cp: null,
  cpDataError: null,
  success: null,
  error: null,
  activeCPManager: null
};

export const cpManagersReducer = (state = initialState, action) => {

  switch (action.type) {
    case actionTypes.UPLOAD_CP_MANAGERS_LIST_START:
      return { ...state, loading: true, error: null, success: null };
    case actionTypes.GET_CP_MANAGERS_LIST_START:
      return { ...state, loading: true, cpManagersListError: null };
    case actionTypes.GET_CP_MANAGERS_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        cpManagersListError: null,
        cpManagersList: action.payload,
      }
    }
    case actionTypes.GET_CP_MANAGERS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        cpManagersListError: action.payload,
        cpManagersList: null,
      };
    case actionTypes.GET_CP_CONTRACT_LIST_START:
      return { ...state, loading: true, cpContractListError: null };
    case actionTypes.GET_CP_CONTRACT_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        cpContractListError: null,
        cpContractList: action.payload,
      }
    }
    case actionTypes.GET_CP_CONTRACT_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        cpContractListError: action.payload,
        cpContractList: null,
      };

    case actionTypes.ADD_CONTRACT_START:
      return { ...state, loading: true, error: null, success: null };
    case actionTypes.ADD_CONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: action.payload.success,
      };
    case actionTypes.ADD_CONTRACT_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
        success: null,
      };


    case actionTypes.EDIT_CP:
      return { ...state, loading: true, error: null, success: null };
    case actionTypes.ADD_NEW_CP_START:
      return { ...state, loading: true, error: null, success: null };
    case actionTypes.ADD_NEW_CP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: action.payload.success,
      }
    case actionTypes.ADD_NEW_CP_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
        success: null,
      };

    case actionTypes.GET_CP_START:
      return { ...state, loading: false, error: null, success: null };
    // case actionTypes.ADD_NEW_CP_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     error: null,
    //     success: action.payload.success,
    //     cp:action.payload.data
    //   };
    // case actionTypes.ADD_NEW_CP_FAILURE:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     cp:null,
    //     loading: false,
    //     success: null,
    //   };

    case actionTypes.ACTIVE_CP_MANAGER:
      return { ...state, activeCPManager: action.payload };
    case actionTypes.CP_MESSAGE_HANDLER:
      return {
        ...state,
        loading: false,
        cpManagersListError: action.payload,
        error: action.payload,
        success: action.payload,
      };

    default:
      return { ...state };
  }
};
